import { toBase64 } from 'js-base64';
import { ExtensionProvider } from '@multiversx/sdk-extension-provider';
import { Address, SignableMessage } from '@multiversx/sdk-core';

export interface IMultiverxSigner {
  signTypedData: (args: { domain: any; types: any; message: any }) => void;
}

export class MultiverxSigner {
  provider: ExtensionProvider;

  constructor(provider: ExtensionProvider) {
    this.provider = provider;
  }

  async signTypedData({ message }: any) {
    try {
      const val = `UserSession@${toBase64(JSON.stringify(message))}`;

      const msg = Buffer.from(val);
      const addr = await this.provider.getAddress();
      const address = new Address(addr);

      const signableMsg = new SignableMessage({
        message: msg,
        address,
      });

      const sig = await this.provider.signMessage(signableMsg);

      return sig.signature.toString('hex');
    } catch (e) {
      console.log('e = ', e);
    }
  }

  async getAccount() {
    const { signature, address } = this.provider.account;
    return address as any;
  }
}
